import moment from 'moment-timezone';
import { DATE_FORMAT } from 'common/adaptive-forms';

export const getFormattedDate = date =>
  date && moment.utc(date).format(DATE_FORMAT);
